import styled from 'styled-components';
import {
  Flex,
} from 'web-styled';

import {
  Button,
  TextInput,
} from 'web-components';

export const Search = styled(Flex).attrs({
  flex: '0 0 60px',
})`
  margin-top: 12px;
  position: relative;
  width: 100%;

  & > div {
    width: 100%;
  }
`;

export const Input = styled(TextInput)`
  color: #2f3539;
  height: 38px;
  border-radius: 20px;
`;

export const SearchButton = styled(Button).attrs({
  type: 'submit',
  appearance: 'link',
})`
  position: absolute;
  top: 0px;
  right: 2px;
  width: 38px;
  height: 38px;
`;
